/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NB_AUTH_OPTIONS, NbAuthSocialLink, NbAuthService, NbAuthResult } from '@nebular/auth';
import { getDeepFromObject } from '../../helpers';
import { EMAIL_PATTERN } from '../constants';
import { Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { InitUserService } from '../../../@theme/services/init-user.service';
import { ApplicationApi } from '../../../@core/backend/common/api/application.api';
import {Ng2TelInputModule} from 'ng2-tel-input';
import { ConfirmationService } from 'primeng/api';
import { NbDialogService } from '@nebular/theme';
import { AdminOtpComponent } from '../admin-otp/admin-otp.component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'ngx-register',
  styleUrls: ['./register.component.scss'],
  templateUrl: './register.component.html',
  providers: [ConfirmationService,],

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxRegisterComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  // minmobileLength:number = 10;
  // maxmobileLength:number = 10;

  // minfirstNameLength:number = 2;
  // maxfirstNameLength:number = 20;

  // minlastNameLength:number = 2;
  // maxlastNameLength:number = 20;
  // mingenderLength:number = 4;
  // maxgenderLength:number = 6;
  // minLoginLength: number = this.getConfigValue(('forms.validation.fullName.minLength'));
  // maxLoginLength: number = this.getConfigValue(('forms.validation.fullName.maxLength'));
  minLength: number = this.getConfigValue('forms.validation.password.minLength');
  maxLength: number = this.getConfigValue('forms.validation.password.maxLength');
  isFullNameRequired: boolean = this.getConfigValue('forms.validation.fullName.required');
  isEmailRequired: boolean = this.getConfigValue('forms.validation.email.required');
  isPasswordRequired: boolean = this.getConfigValue('forms.validation.password.required');
  redirectDelay: number = this.getConfigValue('forms.register.redirectDelay');
  showMessages: any = this.getConfigValue('forms.register.showMessages');
  strategy: string = this.getConfigValue('forms.register.strategy');
  socialLinks: NbAuthSocialLink[] = this.getConfigValue('forms.login.socialLinks');

  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};

  registerForm: FormGroup;
  isMobileRequired: number;
  isLastNameRequired: number;
  isgenderRequired: string;
  displayNo : boolean=false;
  displayNo1 : boolean=true;

  mastersSelected :  boolean = false;
  bachelorsSelected  : boolean = false;
   dbConfig ='/var/www'
   arr =this.dbConfig+  "https://supdc.studentscenter.in/api/sample/pdcgeneral.pdf"
  years_array : number[];
  startYear: any;
  country_name: any;
  readonly charValidate = /^[a-zA-Z ]*$/;
  readonly mobileValidate =/^[0-9]\d{5,12}$/;
  //readonly emailValidate = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
	readonly emailValidate= /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
  readonly passwordValidate = /^[A-Za-z0-9!@#$%^&*()_]{6,}$/;
  defaultCountryCode: boolean;
  countryCode: any = '91';
  mobileInputObj: any;
  checked: boolean;
  emailAlert: boolean;

  emailValue: any;
  display: boolean;
  emailcheck: any;
  emailverify: boolean;
  checked1:boolean=true;
  checked2:boolean=true;
  courseCntrl = new FormControl();
  //
  options1: string[];
  filteredOptions$: Observable<string[]>;
  courseData: any;
  filteredCourses: Observable<[]>;
  lastFilter: string = '';
  selectedCourses = new Array();
  course_enroll: any = [];

  checked3;

  checked4;
  alertflag: number;
  course_name: any;
  filename: string;
  visible: boolean = false;
  changetype: boolean = true;
  imageUrl = environment.imageUrl;

  constructor(protected service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef,
    private fb: FormBuilder,
    protected router: Router,
    protected initUserService: InitUserService,
    private ConfirmationService: ConfirmationService,


    private api: ApplicationApi,
    private dialogService: NbDialogService,) {
  }
  get firstName() { return this.registerForm.get('firstName');}

  get lastName() { return this.registerForm.get('lastName');}
  get fullname() { return this.registerForm.get('fullname');}
  get gender() { return this.registerForm.get('gender');}
  get mobile_country_code() { return this.registerForm.get( this.countryCode );}

  // get login() { return this.registerForm.get('fullName'); }
  get email() { return this.registerForm.get('email'); }
  get mobile() {return this.registerForm.get('mobile');}
  get password() { return this.registerForm.get('password'); }
  get confirmPassword() { return this.registerForm.get('confirmPassword'); }
   get currentlocation() { return this.registerForm.get('currentlocation'); }
  get terms() { return this.registerForm.get('terms'); }
  // get bachleors_enrollment() {return this.registerForm.get('bachleors_enrollment')}
  // get masters_enrollment() {return this.registerForm.get('masters_enrollment')}
  // get PassingYearCtrl() {return this.registerForm.get('PassingYearCtrl')}
  // get bachelorCtrl() {return this.registerForm.get('bachelorCtrl')}
  // get mastersCtrl() {return this.registerForm.get('mastersCtrl')}



  ngOnInit(): void {
    this.api.getCourses().subscribe(data => {
      this.courseData = data['data'];
 
    })


    this.filteredCourses =this.courseCntrl.valueChanges.pipe(
      startWith<string |[]>(''),
      map(value => typeof value === 'string' ? value : this.lastFilter),
      map(filter => this.filter(filter))
    );
    // this.api.getIpAddress().subscribe(data => {
		// 	// this.country_name = data['country'];
		// 	// if(data.country=='India'){
		// 	this.country_name = data['country_name'];
		// 	if(this.country_name=='India'){
		// 		this.registerForm.controls.currentlocation.patchValue("WITHIN");
		// 	}else{
		// 		this.registerForm.controls.currentlocation.patchValue("OUTSIDE");
		// 	}
		// });


    // const mobileValidators =[
    //   Validators.minLength(this.minmobileLength),
    //   Validators.maxLength(this.maxmobileLength),

    // ];
    //  this.isMobileRequired && mobileValidators.push(Validators.required);

    // const firstNameValidators =[
    //   Validators.minLength(this.minfirstNameLength),
    //   Validators.maxLength(this.maxfirstNameLength),

    // ];
    // this.isFullNameRequired && firstNameValidators.push(Validators.required);

    // const lastNameValidators =[
    //   Validators.minLength(this.minlastNameLength),
    //   Validators.maxLength(this.maxlastNameLength),

    // ];
    // const genderValidators =[
    //   Validators.minLength(this.mingenderLength),
    //   Validators.maxLength(this.maxgenderLength),

    // ];
    // if(this.mastersSelected){
    //   // const masters_enrollment = [
    //   //   Validators.required
    //   // ]
    //   masters_enrollment.required()
    // }
    // if(this.bachelorsSelected){
    //   const bachleors_enrollment = [
    //     Validators.required
    //   ]
    // }



    // this.isLastNameRequired && lastNameValidators.push(Validators.required)

    // const loginValidators = [
    //   Validators.minLength(this.minLoginLength),
    //   Validators.maxLength(this.maxLoginLength),
    // ];
    // this.isFullNameRequired && loginValidators.push(Validators.required);

    // const emailValidators = [
    //   Validators.pattern(EMAIL_PATTERN),
    // ];
    // this.isEmailRequired && emailValidators.push(Validators.required);

    // const passwordValidators = [
    //   Validators.minLength(this.minLength),
    //   Validators.maxLength(this.maxLength),
    // ];
    // this.isPasswordRequired && passwordValidators.push(Validators.required);

    this.registerForm = this.fb.group({
      firstName: this.fb.control('', [ Validators.pattern(this.charValidate),Validators.required, Validators.maxLength(70)]),
      lastName: this.fb.control('',[Validators.pattern(this.charValidate), Validators.maxLength(70),Validators.required]),
      fullname:this.fb.control('',[Validators.pattern(this.charValidate), Validators.maxLength(70),Validators.required]),
      gender: this.fb.control('',[Validators.required]),
      
      aadhar: this.fb.control('',[Validators.required,Validators.maxLength(12),Validators.minLength(12)]),
      degreeCtrl: this.fb.control('',[Validators.required]),
      // fullName: this.fb.control('', [...loginValidators]),
      mobile: this.fb.control('',[Validators.required,Validators.maxLength(15),Validators.minLength(10)]),
      email: this.fb.control('', [Validators.required, Validators.pattern(this.emailValidate)]),
      password: this.fb.control('', [Validators.required, Validators.pattern(this.passwordValidate)]),
      confirmPassword: this.fb.control('', [Validators.required, Validators.pattern(this.passwordValidate)]),
       currentlocation: this.fb.control(''),
       enrollment :this.fb.control('',[Validators.maxLength(16),Validators.minLength(12)]),
      terms: this.fb.control(''),



      // masters_enrollment :  this.fb.control(''),
      // bachleors_enrollment :  this.fb.control(''),
      // PassingYearCtrl :  this.fb.control(''),
      // bachelorCtrl :  this.fb.control(''),
      // mastersCtrl :  this.fb.control('')
    });


    const now = new Date().getUTCFullYear();
    this.years_array = Array(now -(now - 50)).fill('').map((v,idx)=> now - idx);

  }

  register(): void {
    this.user = this.registerForm.value;
    this.errors = this.messages = [];
    this.submitted = true;
    this.user.role="student";
    this.user.countryCode=this.countryCode,
    this.user.course_enroll = this.course_enroll
    this.user.countryCode=this.countryCode
    


    this.service.register(this.strategy, this.user).subscribe((result: NbAuthResult) => {
      
      
      this.submitted = false;
      if (result.isSuccess()) {
        

        this.messages = result.getMessages();
      } else {
        this.errors = result.getErrors();
      }
      this.dialogService.open(AdminOtpComponent,{
        closeOnBackdropClick : false,
        context: {
           email : this.user.email,
          // landingPage : '/auth/login',
          value : 'student'
        }
      });

     // const redirect = result.getRedirect();
     const redirect = '/auth/login?verify=' + '1';
     alert("Your Registration is Sucessful. You need to verify your email id before your first login. Kindly check the inbox/spam/junk folder of your registered email id.!");
      if (redirect) {
        setTimeout(() => {
          return this.router.navigateByUrl(redirect);
        }, this.redirectDelay);
      }
      this.cd.detectChanges();
    });
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }
  saveDegree(value,event) {
    if(event.target.checked == true){
      

      if(value == 'Bachleors'){
        this.bachelorsSelected = true

      }if(value =='Masters') {
        this.mastersSelected = true
      }
    }else{
      if(value == 'Bachleors'){
        this.bachelorsSelected = false

      }if(value =='Masters') {
        this.mastersSelected = false
      }
    }
  }
  OnlyNoAllowed(event): boolean {
		const charCode = event.which ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
		  return false;
		}
		return true;
	  }
    onCountryChange(details){
      this.defaultCountryCode = true;
      this.countryCode = details.dialCode;
      

    }
  

    numbersonly(event){
      var regex = new RegExp("^[a-zA-Z0-9]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
       event.preventDefault();
       return false;
    }
      // 
      // const charCode = (event.which) ? event.which : event.keyCode;
      // if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      //   return false;
      // }
      // return true;
    }
    abc2(obj) {
      this.mobileInputObj = obj;
      }

      toggle(click: boolean,duration,status) {
        
          this.checked = click;
        this.displayNo=true
        

        }
        



      
      onKeyPressNew(event:any){
        this.user = this.registerForm.value;
        this.emailcheck= this.user.email
        

        this.api.emailValues(this.emailcheck)
        .subscribe(
          (data: any) => {
          if(data['status'] == 400){
            this.ConfirmationService.confirm({
              message: 'Your email id is already exists in our database!!! Do you want to login on this website using same id and password??',
              icon: 'pi pi-exclamation-triangle',
              accept: () => {
                const redirect = '/auth/login';
                if (redirect) {
                  setTimeout(() => {
                    return this.router.navigateByUrl(redirect);
                  }, this.redirectDelay);
                }
              },
              reject: () => {
              this.emailverify=true

              }
          });


          } else{
          }
          err => console.error(err)
        });


      }


      // onKeyPressNew(event: any) {
      //   this.emailAlert = false;
      //   this.api.emailValues(this.registerForm.controls.email.value)
      //     .subscribe(
      //       (data: any) => {
      //       if(data['status'] == 400){

      //       }else if(data['status'] == 200){
      //         this.confirmationService.confirm({
      //           message: 'Your email id is already exists in our database!!! Do you want to login on this website using same id and password??',
      //           header: 'Confirmation',
      //           icon: 'pi pi-exclamation-triangle',
      //           accept: () => {
      //             this.api.check_in_local_server(this.registerForm.controls.email.value)
      //             .subscribe(
      //               (data: any) => {
      //                 if(data['status'] == 200){
      //                   this.emailAlert = true;
      //                 }else	if(data['status'] == 400){
      //                   this.emailAlert = false;
      //                   this.dialogService.open(ConfirmPassComponent, {
      //                     //hasBackdrop : false,
      //                     //autoFocus : true,
      //                     context: {
      //                      email: this.registerForm.controls.email.value,
      //                     },
      //                    },
      //                    ).onClose
      //                   .subscribe(
      //                     (name : any) => {
      //                       if(name == 'done'){
      //                         this.display = true;
      //                         this.emailValue = this.registerForm.controls.email.value;
      //                       }
      //                     }
      //                   )
      //                 }
      //               }
      //             )
      //           },
      //           reject: () => {
      //             this.emailValue = this.registerForm.controls.email.value;
      //             this.displayNo = true;
      //           }
      //         });
      //       }else if(data['status'] == 402){
      //         this.confirmationService.confirm({
      //           message: 'Your email id is already exists in our database!!! Do you want to login on this website using same id and password??',
      //           header: 'Confirmation',
      //           icon: 'pi pi-exclamation-triangle',
      //           accept: () => {
      //             this.router.navigate(['auth/login']);
      //           },
      //           reject: () => {
      //             this.emailValue = this.registerForm.controls.emailCtrl.value;
      //             this.displayNo = true;
      //           }
      //         });
      //       } else{
      //       }
      //       err => console.error(err)
      //     });
      // };


  getSelectedYear(){
    var d = new Date();
    const now = new Date().getUTCFullYear();
    this.years_array = Array(now -(now - 50)).fill('').map((v,idx)=> now - idx);
    if(this.registerForm.controls.PassingYearCtrl.value){
      this.startYear = this.registerForm.controls.PassingYearCtrl.value;
      this.startYear = Number(this.startYear)
    }




  }
  // initUser() {
  //   this.initUserService.initCurrentUser()
  //     .pipe(
  //       takeUntil(this.destroy$),
  //     )
  //     .subscribe();
  // }
  toggle1(condition,checked: boolean) {
    

    
    if(condition=='1')
    {
      this.checked1=checked
    }else if(condition=='2'){
      this.checked2=checked
    }else if(condition=='3'){
      this.checked3=checked
    }else if(condition=='4'){
      this.checked4=checked
    }

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  filter(filter: string): [] {
    this.lastFilter = this._normalizeValue(filter);

    // this.lastFilter = filter;
    if (filter) {
      return this.courseData.filter(option =>
        option.name.toLowerCase().includes(this.lastFilter)
      );
    } else {
     // return this.courseData.slice();
    }
  }
  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, "");
  }

  displayFn(value: [] | string): string | undefined {
    let displayValue: string;
    if (Array.isArray(value)) {
      value.forEach((course, index) => {
        if (index === 0) {
          displayValue = course;
        } else {
          displayValue += ', ' + course;
        }
      });
    } else {
      displayValue = value;
    }
    return displayValue;
  }

  optionClicked(event: Event, course) {
    
    
    event.stopPropagation();
    this.toggleSelection(course);
  }

  toggleSelection(course) {
    
    
    course.selected = !course.selected;
    if (course.selected) {
    this.selectedCourses.push({
      course:course.name,
      degree_type:course. degree_type
    })
    } else {
      const i = this.selectedCourses.findIndex(value => value.firstname === course.firstname && value.lastname === course.lastname);
      this.selectedCourses.splice(i, 1);
    }

    this.courseCntrl.setValue(course.name);
  }
  setEnrollmentNo(course,degree_type,event){


    var temp = this.course_enroll.some(value => value.course === course)
    if(temp == false){
      this.course_enroll.push({
        course : course,
        enrollmentNo : event.target.value,
        source:'solpdc',
        degree_type:degree_type
      })
    }else{
      this.course_enroll.forEach(value => {
        if(value.course === course){
          value.enrollmentNo = event.target.value;
        }
      })
    }
    
  }
  numberOnly(event){
    
    
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
  OnlyCharAllowed(event):boolean{
    
    
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 31 || charCode > 96 || charCode < 105) {
      return false;
    }
    return true;
  }

  viewpass(){
    this.visible = !this.visible;
    this.changetype = this.viewpass ? false : true;
  }
}
